import React from 'react';
import { MapFermaStatus, StartTimerStates, FinishStates } from '../../FermaHelper';
import {
    CircularProgress
} from '@mui/material';
import { Button } from 'reactstrap';
import { TeamManagementPanel } from './TeamManagment/TeamManagementPanel'
import { formatDuration, formatDateTime } from './TimeFormatter';

export const ProcessingStatus = ({
    id = null,
    status = null,
    fileNames = [],
    comment = null,
    error = null,
    isActive = false,
    isWaiting = false,
    currentUserAccess = null,
    fileRecords = [],
    onCreatorTransferred = null,
    timerElapsedTime = 0,
    onNavigateToNext = null,
}) => {
    const normalizedStatus = status?.status || 'None';
    const statusText = MapFermaStatus(normalizedStatus).replace(/Задача/g, 'Операция');
    const isInProgress = StartTimerStates.includes(normalizedStatus);
    const isFinished = FinishStates.includes(normalizedStatus);

    const pathParts = window.location.pathname.split('/').filter(part => part !== '');
    const inpitIdentifier = pathParts[pathParts.length - 1];

    const displayTime = formatDuration(timerElapsedTime);

    return (
        <div className="processing-status">
            <div className="status-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="status-info">
                    <div className="file-names">
                        <p>
                            <strong>Id:</strong>
                            &ensp;
                            <em>
                                {id}
                            </em>
                        </p>
                    </div>
                    <div className="file-names">
                        <p>
                            <strong>{fileNames?.length === 1 ? 'Исходный Файл' : 'Исходные Файлы'}:</strong>
                            &ensp;
                            <em>
                                {fileNames?.length > 0
                                    ? fileNames.map(f => `"${f}"`).join(', ')
                                    : 'не указаны'}
                            </em>
                        </p>
                    </div>

                    <div className="status-line">
                        <strong>Статус:</strong>
                        &ensp;
                        <em>{statusText || 'Неизвестный статус'}</em>
                        {isInProgress && isActive && (
                            <CircularProgress size={20} style={{ marginLeft: 10 }} color="primary" />
                        )}
                    </div>
                    {comment && (
                        <div className="comment-line">
                            <p>
                                <strong>Комментарий:</strong>
                                &ensp;
                                <em>
                                    {comment}
                                </em>
                            </p>
                        </div>
                    )}
                </div>

                <div className="share-buttons">
                    {isFinished && normalizedStatus === "Finished" && (
                        <>
                            <TeamManagementPanel
                                id={id}
                                inpitIdentifier={inpitIdentifier}
                                currentUserAccess={currentUserAccess}
                                fileRecords={fileRecords}
                                onCreatorTransferred={onCreatorTransferred}
                            />

                            {status?.nextUtilityEndpoint && status?.nextTaskIdentifier && onNavigateToNext && (
                                <Button
                                    className="dt1520-button active-dt1520-button"
                                    onClick={onNavigateToNext}
                                    style={{ marginLeft: '10px' }}
                                >
                                    Перейти к следующему этапу
                                </Button>
                            )}
                        </>
                    )}
                </div>
            </div>

            {(isInProgress || FinishStates.includes(normalizedStatus)) && (
                <div className="timing-info">
                    <p>
                        <strong>Начало обработки:</strong>
                        &ensp;
                        <em>
                            {status?.startTime
                                ? formatDateTime(status?.startTime)
                                : 'не зафиксировано'}
                        </em>
                    </p>
                    <p>
                        <strong>Общее время выполнения:</strong>
                        &ensp;
                        <em>
                            {displayTime}
                        </em>
                    </p>
                </div>
            )}

            {status?.plannedStartTime && new Date(status?.plannedStartTime) > new Date() ? (
                <div className="scheduled-message">
                    <p>Задача запланирована на {new Date(status?.plannedStartTime).toLocaleString()}</p>
                </div>
            ) : isWaiting ? (
                <div className="waiting-message">
                    <p>Файл находится в очереди на обработку. Пожалуйста, подождите...</p>
                </div>
            ) : null}

            {error && (
                <div className="error-message">
                    <p>
                        <strong>Ошибка:</strong>
                        &ensp;
                        <em>{error}</em>
                    </p>
                </div>
            )}
        </div>
    );
};